<template>
  <div>
    <template v-if="listaTodos.length < 1">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay convenios registrados. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="auto" class="py-0 px-1">
          <v-btn-toggle v-model="vistaConvenios">
            <v-btn small>
              <v-icon small left>format_list_numbered</v-icon>
              <small>Histórico</small>
            </v-btn>
            <v-btn small>
              <v-icon small left>view_stream</v-icon>
              <small>Agrupado</small>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-expand-transition>
        <v-card
          flat
          color="rounded-lg"
          v-show="vistaConvenios === 0"
          class="mt-3">
          <v-card-text>
            <v-skeleton-loader
              v-if="$apollo.loading"
              type="table-heading, table-thead, table-tbody"
            ></v-skeleton-loader>
            <v-data-table
              v-if="!$apollo.loading"
              :headers="headerTodos"
              :items="listaTodos"
              sort-by="createdAt"
              sort-desc>
              <template v-slot:[`item.fecha`]="{ item }">
                <!-- {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }} -->
                {{ $moment(item.fecha).format('D/M/YYYY') }}
              </template>
              <template v-slot:[`item.numero`]="{ item }">
                <v-chip
                  small
                  dark
                  :color="convenioColor(item)">
                  <b>{{ item.numero }}</b>
                </v-chip>
              </template>
              <template
                v-slot:[`item.importeCostoDirecto`]="{ item }">
                {{ item.importeCostoDirecto | currency }}
              </template>
              <template
                v-slot:[`item.importeCostoIndirectos`]="{ item }">
                {{ item.importeCostoIndirectos | currency }}
              </template>
              <template
                v-slot:[`item.importeUtilidad`]="{ item }">
                {{ item.importeUtilidad | currency }}
              </template>
              <template
                v-slot:[`item.importeCargosAdicionales`]="{ item }">
                {{ item.importeCargosAdicionales | currency }}
              </template>
              <template
                v-slot:[`item.importeCostoFinanciero`]="{ item }">
                {{ item.importeCostoFinanciero | currency }}
              </template>
              <template v-slot:[`item.importe`]="{ item }">
                <b :class="colorDinero(item.importe)">
                  {{ item.importe | currency }}
                </b>
                </template>
                <template v-slot:[`item.iva`]="{ item }">
                  <b :class="colorDinero(item.iva)">
                    {{ item.iva | currency }}
                  </b>
                </template>
                <template v-slot:[`item.total`]="{ item }">
                  <b :class="colorDinero(item.total)">
                    {{ item.total | currency }}
                  </b>
                </template>
              <template v-slot:[`item.fechaInicio`]="{ item }">
                <b class="base8--text">
                  <!-- {{ new Date(`${item.fechaInicio} 00:00:0`).toLocaleDateString() }} -->
                  {{ $moment(item.fechaInicio).format('D/M/YYYY') }}
                </b>
              </template>
              <template v-slot:[`item.fechaTermino`]="{ item }">
                <b class="error--text">
                  <!-- {{ new Date(`${item.fechaTermino} 00:00:0`).toLocaleDateString() }} -->
                  {{ $moment(item.fechaTermino).format('D/M/YYYY') }}

                </b>
              </template>
              <template v-slot:[`item.acciones`]="{ item }" v-if="!readOnly">
                <template v-if="!$vuetify.breakpoint.mobile">
                  <v-tooltip
                    v-if="mixValidaScopesActions(2)"
                    top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip
                    v-if="mixValidaScopesActions(3)"
                    top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar</span>
                    </v-tooltip>
                </template>
                <template v-else>
                  <opciones :convenio="item"></opciones>
                </template>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-expand-transition>
      <v-expand-transition>
        <div v-show="vistaConvenios === 1">
          <v-row align="center" class="d-flex align-stretch my-3" width="100%">
            <v-sheet width="auto" class="base1 rounded-l-lg d-flex">
              <v-col cols="auto" class="align-self-center">
                <span class="white--text">P</span><br />
                <span class="white--text">L</span><br />
                <span class="white--text">A</span><br />
                <span class="white--text">Z</span><br />
                <span class="white--text">O</span>
              </v-col>
            </v-sheet>
            <v-card flat color="rounded-r-lg" width="96.5%">
              <v-skeleton-loader
                v-if="$apollo.loading"
                type="table-heading, table-thead, table-tbody"
              ></v-skeleton-loader>
              <v-card-text>
                <v-data-table
                  v-if="!$apollo.loading"
                  dense
                  :headers="headersPlazo"
                  :items="listaPlazo"
                  sort-by="createdAt"
                  sort-desc
                >
                  <template v-slot:[`item.fecha`]="{ item }">
                    <!-- {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }} -->
                    {{ $moment(item.fecha).format('D/M/YYYY') }}
                  </template>
                  <template v-slot:[`item.fechaInicio`]="{ item }">
                    <!-- {{ new Date(`${item.fechaInicio} 00:00:0`).toLocaleDateString() }} -->
                    {{ $moment(item.fechaInicio).format('D/M/YYYY') }}
                  </template>
                  <template v-slot:[`item.fechaTermino`]="{ item }">
                    <!-- {{ new Date(`${item.fechaTermino} 00:00:0`).toLocaleDateString() }} -->
                    {{ $moment(item.fechaTermino).format('D/M/YYYY') }}
                  </template>
                  <template v-slot:[`item.acciones`]="{ item }" v-if="!readOnly">
                    <template v-if="!$vuetify.breakpoint.mobile">
                      <v-tooltip
                        v-if="mixValidaScopesActions(2)"
                        top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip
                        v-if="mixValidaScopesActions(3)"
                        top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Borrar</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                      <opciones :convenio="item"></opciones>
                    </template>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-row>
          <v-row align="center" class="d-flex align-stretch my-3">
            <v-sheet width="auto" class="base2 rounded-l-lg d-flex">
              <v-col cols="auto" class="align-self-center">
                <span class="white--text">M</span><br />
                <span class="white--text">O</span><br />
                <span class="white--text">N</span><br />
                <span class="white--text">T</span><br />
                <span class="white--text">O</span>
              </v-col>
            </v-sheet>
            <v-card flat color="rounded-r-lg" width="96.5%">
              <v-card-text>
                <v-skeleton-loader
                  v-if="$apollo.loading"
                  type="table-heading, table-thead, table-tbody"
                ></v-skeleton-loader>
                <v-data-table
                  v-if="!$apollo.loading"
                  dense
                  :headers="headersMonto"
                  :items="listaMonto"
                  sort-by="createdAt"
                  sort-desc
                >
                  <template v-slot:[`item.fecha`]="{ item }">
                    <!-- {{ new Date(item.fecha).toLocaleDateString() }} -->
                    {{ $moment(item.fecha).format('D/M/YYYY') }}
                  </template>
                  <template v-slot:[`item.importe`]="{ item }">
                    {{ item.importe | currency }}
                  </template>
                  <template v-slot:[`item.iva`]="{ item }">
                    {{ item.iva | currency }}
                  </template>
                  <template v-slot:[`item.total`]="{ item }">
                    {{ item.total | currency }}
                  </template>
                  <template v-slot:[`item.acciones`]="{ item }" v-if="!readOnly">
                    <template v-if="!$vuetify.breakpoint.mobile">
                      <v-tooltip
                        v-if="mixValidaScopesActions(2)"
                        top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip
                        v-if="mixValidaScopesActions(3)"
                        top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Borrar</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                      <opciones :convenio="item"></opciones>
                    </template>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-row>
          <v-row align="center" class="d-flex align-stretch my-3">
            <v-sheet width="auto" class="naranja rounded-l-lg d-flex">
              <v-col cols="auto" class="align-self-center">
                <span class="white--text">M</span><br />
                <span class="white--text">E</span><br />
                <span class="white--text">T</span><br />
                <span class="white--text">A</span>
              </v-col>
            </v-sheet>
            <v-card flat color="rounded-r-lg" width="96.5%">
              <v-card-text>
                <v-skeleton-loader
                  v-if="$apollo.loading"
                  type="table-heading, table-thead, table-tbody"
                ></v-skeleton-loader>
                <v-data-table
                  v-if="!$apollo.loading"
                  dense
                  width="100%"
                  :headers="headersMeta"
                  :items="listaMeta"
                  sort-by="createdAt"
                  sort-desc
                >
                  <template v-slot:[`item.fecha`]="{ item }">
                    <!-- {{ new Date(item.fecha).toLocaleDateString() }} -->
                    {{ $moment(item.fecha).format('D/M/YYYY') }}
                  </template>
                  <template v-slot:[`item.acciones`]="{ item }" v-if="!readOnly">
                    <template v-if="!$vuetify.breakpoint.mobile">
                      <v-tooltip
                        v-if="mixValidaScopesActions(2)"
                        top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip
                        v-if="mixValidaScopesActions(3)"
                        top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Borrar</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                      <opciones :convenio="item"></opciones>
                    </template>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-row>
        </div>
      </v-expand-transition>
    </template>
  </div>
</template>

<script>
import CONTRATO_CONVENIOS_MODIFICATORIOS from '@/graphql/querys/administracion/contratos/contrato/convenios.gql';
import Opciones from './Opciones.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoContratoConveniosDesktop',
  props: {
    readOnly: Boolean,
  },
  components: {
    Opciones,
  },
  apollo: {
    contratoConveniosModificatorios: {
      query: CONTRATO_CONVENIOS_MODIFICATORIOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  data() {
    return {
      vistaConvenios: 0,
      headerTodos: [
        {
          text: 'Fecha',
          align: 'start',
          sortable: false,
          value: 'fecha',
        },
        {
          text: 'Número',
          sortable: false,
          value: 'numero',
        },
        {
          text: 'Meta',
          value: 'objeto',
          sortable: false,
        },
        {
          text: 'Importe',
          value: 'importe',
          sortable: false,
          align: 'end',
        },
        {
          text: 'I.V.A',
          value: 'iva',
          sortable: false,
          align: 'end',
        },
        {
          text: 'Total',
          value: 'total',
          sortable: false,
          align: 'end',
        },
        {
          text: 'F. Inicio',
          value: 'fechaInicio',
          sortable: false,
        },
        {
          text: 'F. Termino',
          value: 'fechaTermino',
          sortable: false,
        },
        {
          text: '',
          align: 'end',
          value: 'acciones',
          sortable: false,
        },
      ],
      headersPlazo: [
        {
          text: 'Fecha',
          align: 'start',
          sortable: false,
          value: 'fecha',
        },
        {
          text: 'Número',
          sortable: false,
          value: 'numero',
        },
        {
          text: 'F. Inicio',
          value: 'fechaInicio',
          sortable: false,
        },
        {
          text: 'F. Termino',
          value: 'fechaTermino',
          sortable: false,
        },
        {
          text: '',
          align: 'end',
          value: 'acciones',
          sortable: false,
        },
      ],
      headersMeta: [
        {
          text: 'Fecha',
          align: 'start',
          sortable: false,
          value: 'fecha',
        },
        {
          text: 'Número',
          sortable: false,
          value: 'numero',
        },
        {
          text: 'Meta',
          value: 'objeto',
          sortable: false,
        },
        {
          text: '',
          align: 'end',
          value: 'acciones',
          sortable: false,
        },
      ],
      headersMonto: [
        {
          text: 'Fecha',
          align: 'start',
          sortable: false,
          value: 'fecha',
        },
        {
          text: 'Número',
          sortable: false,
          value: 'numero',
        },
        {
          text: 'C. Directo',
          value: 'importeCostoDirecto',
          sortable: false,
          align: 'end',
        },
        {
          text: 'C. Indirectos',
          value: 'importeCostoIndirectos',
          sortable: false,
          align: 'end',
        },
        {
          text: 'Utilidad',
          value: 'importeUtilidad',
          sortable: false,
          align: 'end',
        },
        {
          text: 'C. Adicionales',
          value: 'importeCargosAdicionales',
          sortable: false,
          align: 'end',
        },
        {
          text: 'C. Financiero',
          value: 'importeCostoFinanciero',
          sortable: false,
          align: 'end',
        },
        {
          text: 'Importe',
          value: 'importe',
          sortable: false,
          align: 'end',
        },
        {
          text: 'I.V.A',
          value: 'iva',
          sortable: false,
          align: 'end',
        },
        {
          text: 'Total',
          value: 'total',
          sortable: false,
          align: 'end',
        },
        {
          text: '',
          align: 'end',
          value: 'acciones',
          sortable: false,
        },
      ],
      idContrato: this.$route.params.idContrato,
    };
  },
  methods: {
    convenioColor(item) {
      switch (item.tipo) {
        case 'PLAZO':
          return 'base1';
        case 'CAMBIO DE META':
          return 'naranja';
        case 'MONTO - REDUCCIÓN':
          return 'base2';
        case 'MONTO - AMPLIACIÓN':
          return 'base2';
        default:
          return '';
      }
    },
    colorDinero(numero) {
      if (!numero) return '';
      if (numero > 0) return 'success--text';
      return 'error--text';
    },
    editar(convenio) {
      eventBus.$emit('editar-convenio-modificatorio', convenio);
    },
    borrar(convenio) {
      eventBus.$emit('eliminar-convenio-modificatorio', convenio);
    },
  },
  computed: {
    listaTodos() {
      if (!this.contratoConveniosModificatorios) return [];
      return this.contratoConveniosModificatorios;
    },
    listaPlazo() {
      return this.listaTodos.filter((item) => item.tipo === 'PLAZO');
    },
    listaMeta() {
      return this.listaTodos.filter((item) => item.tipo === 'CAMBIO DE META');
    },
    listaMonto() {
      return this.listaTodos.filter((item) => item.tipo.substr(0, 5) === 'MONTO');
    },
  },
};
</script>

<style lang="scss"></style>
